class Builder {

  constructor(query) {
    this.sku = this.parseQueryString(query).sku;
    this.post = this.parseQueryString(query).post;
    this.setComponentDefaults(this.getSkuObject(this.sku));
    this.updateRadioButtons();
    this.setRadioOptions(window.options_json);
    this.renderDomain = 'https://salterspiralstair.s3.amazonaws.com/renders/';
  }

  update() {
    this.setSummary();
    this.updateSku();
    this.updateFormSku();
    this.updateFormProduct();
    this.updateFormOptions();
    this.printSummary(this.setSummary());
    this.updateApplicableOptions();
    this.updateSelectFromRadio();
    this.setRender();
  }

  //------------------------------------------------//
  //------------------- FUNCTIONS ------------------//
  //------------------------------------------------//

  /*
  * Set dynamic renders
  */
  setRender() {
    const render_path_desktop = this.getRenderPathDesktop();
    const render_path_mobile = this.getRenderPathMobile();
    let img = this.getRenderImage() + '.jpg';

    $('<img/>').attr('src', render_path_desktop + img).on('load', function() {
      $(this).remove();
      $('.paragon_product_image_wrapper').css('background-image', 'url('+ render_path_desktop + img +')');
    });

    $('<img/>').attr('src', render_path_mobile + img).on('load', function() {
      $(this).remove();
      $('.paragon_mobile_product_image_wrapper').css('background-image', 'url('+ render_path_mobile + img +')');
    });
  }

  /*
  * Adds image and description to component options (radio buttons)
  */
  setRadioOptions(obj) {
    if (obj) {
      $.each(obj, function(i, item) {
        var el = $('#' + item.option_name.value + ' ' + '.radio-item[data-value="'+ item.option_title.replace(/"/g, '\\"') +'"]').find('label');

        $(el).find('span.image').css('background-image', 'url('+ item.option_image +')');
        $(el).find('span.description').text(item.option_description);
        $(el).attr('data-error-message', item.option_error_message);
      });
    }
  }

  /*
  * Updates hidden select with selected radio button value
  */
  updateSelectFromRadio() {
    $('.component .radio-item label').on('click', function() {
      var radio_value = $(this).closest('.radio-item').data('value');

      $(this).closest('.btn-group').find('.radio-item[data-selected="true"]').attr('data-selected', 'false');
      $(this).closest('td.value').find('select').val(radio_value).trigger('change');
      $(this).closest('.radio-item').attr('data-selected', 'true');
    });
  }

  /*
  * Updates radio buttons based on initial sku
  */
  updateRadioButtons() {
    $('.radio-item').attr('data-selected', 'false');

    $('.component').each(function(i, component) {
      $(component).find('.attribute_options').each(function(j, item) {
        var current_select_value = $(item).find('select').val();

        $(item).find('.radio-item').each(function(k, radio) {
          var radio_value = $(radio).data('value');

          if (current_select_value == radio_value) {
            $(radio).attr('data-selected', 'true');
          }
        });
      });
    });
  }

  /*
  * Updates options depending on conditional logic
  */
  updateApplicableOptions() {
    var current_options = $('.component .attribute_options');

    $('.btn-group .radio-item').addClass('disabled');

    current_options.each(function(i, item) {
      var current_radio_options = $(item).find('.btn-group .radio-item'),
          current_select_options = $(item).find('select').find('option');

      current_radio_options.each(function(j, radio) {
        var radio_value = $(radio).data('value');

        current_select_options.each(function(k, select) {
          var option_value = $(select).attr('value');

          if (radio_value == option_value && !$(select).is(':disabled')) {
            $(radio).removeClass('disabled');
          }
        });
      });
    });
  }

  /*
  * Update sku in conversion form
  */
  updateFormSku() {
    $('.gform_wrapper .gfield.update-form-sku input').val(this.sku);
  }

  /*
  * Update product title in conversion form
  */
  updateFormProduct() {
    $('.gform_wrapper .gfield.update-form-product input').val($('.cart.composite_form').data('product-title'));
  }

  /*
  * Update options in conversion form
  */
  updateFormOptions() {
    var options = '',
        _this = this;

    $.each(this.selection_data, function(i, item) {
      switch(i) {
        case 'width':
          options += 'Width: ' + _this.getValueByKey(_this.widthObject(), item) + ' | ';
          break;

        case 'height':
          options += 'Height: ' + _this.getValueByKey(_this.heightObject(), item) + ' | ';
          break;

        case 'finish':
          options += 'Finish: ' + _this.getValueByKey(_this.finishObject(), item) + ' | ';
          break;

        case 'tread_type':
          options += 'Tread Type: ' + _this.getValueByKey(_this.treadTypeObject(), item) + ' | ';
          break;

        case 'tread_profile':
          options += 'Tread Profile: ' + _this.getValueByKey(_this.treadProfileObject(), item) + ' | ';
          break;

        case 'tread_cover':
          options += 'Tread Cover: ' + _this.getValueByKey(_this.treadCoverObject(), item) + ' | ';
          break;

        case 'tread_material':
          options += 'Tread Material: ' + _this.getValueByKey(_this.treadMaterialObject(), item) + ' | ';
          break;

        case 'tread_covering':
          options += 'Tread Covering: ' + _this.getValueByKey(_this.treadCoveringObject(), item) + ' | ';
          break;

        case 'wood_covering_type':
          options += 'Wood Covering Type: ' + _this.getValueByKey(_this.woodCoveringTypeObject(), item) + ' | ';
          break;

        case 'handrail':
          options += 'Handrail: ' + _this.getValueByKey(_this.handrailObject(), item) + ' | ';
          break;

        case 'number_of_platform_rails':
          options += 'Number of Platform Rails: ' + _this.getValueByKey(_this.platformRailObject(), item) + ' | ';
          break;

        case 'baluster_type':
          options += 'Baluster Type: ' + _this.getValueByKey(_this.balusterTypeObject(), item) + ' | ';
          break;

        case 'baluster_pattern':
          options += 'Baluster Pattern: ' + _this.getValueByKey(_this.balusterPatternObject(), item) + ' | ';
          break;

        case 'wood_species':
          options += 'Wood Species: ' + _this.getValueByKey(_this.woodSpeciesObject(), item) + ' | ';
          break;
      }
    });

    $('.gform_wrapper .gfield.update-form-options input').val(options.slice(0, -3));
  }

  /*
  * Update sku in the url
  */
  updateSku() {
    this.setSku();
    let query = '?sku=' + this.sku + '&post=' + this.post;

    if (query) {
      window.history.replaceState(null, null, query);
    }
  }

  /*
  * Find components
  */
  setComponentDefaults(obj) {
    var _this = this;

    if (obj) {
      $('.component').each(function(i, component) {
        $(component).find('.attribute_options').each(function(j, item) {
          var label = _this.createLabel($(item).data('attribute_label')),
              slug = _this.createSlug(label);

          _this.setValue(slug, item);
        });
      });
    }
  }

  /*
  * Set components default value
  */
  setValue(slug, el) {
    let obj = {};

    switch(slug) {
      case 'width':
        obj = this.widthObject();
        break;

      case 'height':
        obj = this.heightObject();
        break;

      case 'finish':
        obj = this.finishObject();
        break;

      case 'tread_type':
        obj = this.treadTypeObject();
        break;

      case 'tread_profile':
        obj = this.treadProfileObject();
        break;

      case 'tread_cover':
        obj = this.treadCoverObject();
        break;

      case 'tread_material':
        obj = this.treadMaterialObject();
        break;

      case 'tread_covering':
        obj = this.treadCoveringObject();
        break;

      case 'wood_covering_type':
        obj = this.woodCoveringTypeObject();
        break;

      case 'handrail':
        obj = this.handrailObject();
        break;

      case 'number_of_platform_rails':
        obj = this.platformRailObject();
        break;

      case 'baluster_type':
        obj = this.balusterTypeObject();
        break;

      case 'baluster_pattern':
        obj = this.balusterPatternObject();
        break;

      case 'wood_species':
        obj = this.woodSpeciesObject();
        break;
    }

    $(el).find('select').val(this.getValueByKey(obj, this.selection_data[slug]));
  }

  /*
  * Update selection data
  */
  updateValue(slug, value) {
    let obj = {};

    switch(slug) {
      case 'width':
        obj = this.widthObject();
        break;

      case 'height':
        obj = this.heightObject();
        break;

      case 'finish':
        obj = this.finishObject();
        break;

      case 'tread_type':
        obj = this.treadTypeObject();
        break;

      case 'tread_profile':
        obj = this.treadProfileObject();
        break;

      case 'tread_cover':
        obj = this.treadCoverObject();
        break;

      case 'tread_material':
        obj = this.treadMaterialObject();
        break;

      case 'tread_covering':
        obj = this.treadCoveringObject();
        break;

      case 'wood_covering_type':
        obj = this.woodCoveringTypeObject();
        break;

      case 'handrail':
        obj = this.handrailObject();
        break;

      case 'number_of_platform_rails':
        obj = this.platformRailObject();
        break;

      case 'baluster_type':
        obj = this.balusterTypeObject();
        break;

      case 'baluster_pattern':
        obj = this.balusterPatternObject();
        break;

      case 'wood_species':
        obj = this.woodSpeciesObject();
        break;
    }

    this.setSelectionData(slug, this.getKeyByValue(obj, value));
  }

  /*
  * Update selection data
  */
  setSelectionData(key, value) {
    this.selection_data[key] = value;
  }

  /*
  * Creates summary array
  */
  setSummary() {
    var data = [],
    _this = this;

    $('.composite_form .component').each(function(i, elem) {
      var elem_id = $(elem).data('item_id'),
          elem_title = $(elem).data('nav_title');

      if (elem_title) {
        data[elem_title] = [];
      }

      $('#component_' + elem_id + ' .attribute_options').each(function(j, component) {
        var label_raw = $(component).data('attribute_label'),
            label = _this.createLabel(label_raw),
            slug = _this.createSlug(label);

        $(component).find('.value > select').each(function(k, field) {
          var value = field.value;

          if (value) {
            _this.updateValue(slug, value);

            data[elem_title].push({
              'label': label,
              'value': value,
            });
          }
        });
      });
    });

    return data;
  }

  /*
  * Creates summary block wrapper + outputs summary content
  */
  createSummaryWrapper(title, object) {
    const summary_wrapper_template = $('#tpl_summary_wrapper');
    var clone = summary_wrapper_template.clone().prop('content');
    let _this = this;

    if (object) {
      if (clone) {
        $(clone).find('.summary-title').text(title);

        $.each(object, function(i, el) {
          var clone_content = _this.createSummaryContent(el);
          $(clone).find('.summary-item > .row').append(clone_content);
        })
      }
    }

    return clone;
  }

  /*
  * Creates summary content
  */
  createSummaryContent(object) {
    const summary_content_template = $('#tpl_summary_content');
    var clone = summary_content_template.clone().prop('content');

    if (object) {
      if (clone) {
        $(clone).find('.summary-label').text(object.label);
        $(clone).find('.summary-value').text(object.value);
      }
    }

    return clone;
  }

  /*
  * Prints summary to the page
  */
  printSummary(object) {
    if (object) {
      $('.composite_form .summary-wrapper .summary-item-wrapper > .row').empty();

      for (var el in object) {
        var clone_wrapper = this.createSummaryWrapper(el, object[el]);
        $('.composite_form .summary-wrapper .summary-item-wrapper > .row').append(clone_wrapper);
      }
    }
  }

  /*
  * Helper Function - Get Key By Value
  */
  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  /*
  * Helper Function - Get Key By Value
  */
  getValueByKey(object, key) {
    return object[key]
  }

  /*
  * Parse query strings
  */
  parseQueryString(query) {
    var params = {}, queries, temp, i, l;

    queries = query.split('&');

    for (i = 0, l = queries.length; i < l; i++) {
      temp = queries[i].split('=');
      params[temp[0]] = decodeURIComponent(temp[1]);
    }

    return params;
  }

  /*
  * Creates label from string (ONLY FOR SALTER)
  */
  createLabel(str) {
    if (str) {
      str = str.replace('Select a', '').replace('Select the', '').replace('for Your Stair', '').replace('For Your Stair', '').trim();
    }

    return str;
  }

  /*
  * Create slug from string
  */
  createSlug(str) {
    if (str) {
      str = str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '_').replace(/^-+|-+$/g, '');
    }

    return str;
  }

  //------------------------------------------------//
  //-------------------- OBJECTS -------------------//
  //------------------------------------------------//

  /*
  * Width lookup
  */
  widthObject() {
    return {
      '36' : '3\' 6"',
      '40' : '4\' 0"',
      '46' : '4\' 6"',
      '50' : '5\' 0"',
      '56' : '5\' 6"',
      '60' : '6\' 0"',
    }
  }

  /*
  * Height lookup
  */
  heightObject() {
    return {
      '09' : '7\' 1" - 7\' 11" (9 Treads)',
      '10' : '7\' 9" - 8\' 8" (10 Treads)',
      '11' : '8\' 5" - 9\' 6" (11 Treads)',
      '12' : '9\' 2" - 10\' 3" (12 Treads)',
      '13' : '9\' 11" - 11\' 1" (13 Treads)',
      '14' : '10\' 7" - 11\' 10" (14 Treads)',
      '15' : '11\' 4" - 12\' 8" (15 Treads)',
    }
  }

  /*
  * Tread profile lookup
  */
  treadProfileObject() {
    return {
      'S' : 'Standard',
      'D' : 'Line Rail',
      'B' : 'Riser Bar',
      'R' : 'Code Riser',
      'L' : 'Long Curved',
      'I' : 'Ivy Stencil',
      'C' : 'Curved Up',
    }
  }

  /*
  * Tread type lookup
  */
  treadTypeObject() {
    return {
      'S' : 'Smooth',
      'D' : 'Diamond Plate',
      'R' : 'Red Oak',
    }
  }

  /*
  * Tread material lookup
  */
  treadMaterialObject() {
    return {
      'M' : 'Metal',
      'L' : 'Laminate',
    }
  }

  /*
  * Tread covering lookup
  */
  treadCoveringObject() {
    return {
      'S' : 'Standard',
      'B' : 'Smooth',
      'F' : 'Fan Cut Grated',
      'D' : 'Diamond Plate',
      'W' : 'Solid Wood Tread Cover',
      'C' : 'Composite Tread Cover',
    }
  }

  /*
  * Tread cover lookup (Not the same as tread covering)
  */
  treadCoverObject() {
    return {
      'N' : 'None',
      'C' : 'Anti-Slip',
    }
  }

  /*
  * Wood covering type lookup
  */
  woodCoveringTypeObject() {
    return {
      'N' : 'None',
      'A' : 'Red Oak',
      'L' : 'Mahogany',
      'K' : 'Teak',
      'D' : 'Brazilian Cherry',
      'E' : 'Call For More Options',
    }
  }

  /*
  * Finish lookup
  */
  finishObject() {
    return {
      'P' : 'Primed Steel',
      'G' : 'Galvanized',
      'N' : 'Black Powder Coat',
      'B' : 'White Powder Coat',
      'C' : 'Gray Powder Coat',
      'D' : 'Call For More Options',
    }
  }

  /*
  * Handrail lookup
  */
  handrailObject() {
    return {
      'V' : 'Vinyl',
      'A' : 'Aluminum',
      'W' : 'Solid Wood 2" Round',
      'X' : 'Solid Wood 3" Round',
      'G' : 'Solid Wood 3" Bead & Finger Groove',
    }
  }

  /*
  * Baluster type lookup
  */
  balusterTypeObject() {
    return {
      'A' : 'Standard Tube Baluster',
      'B' : 'Stainless Steel Line Rail',
    }
  }

  /*
  * Baluster pattern lookup
  */
  balusterPatternObject() {
    return {
      'A' : 'Forged Standard',
      'B' : 'Forged Weave',
      'C' : 'Forged Feather',
      'D' : 'Forged Double Ornate Twist',
      'E' : 'Forged Ornate Twist',
      'F' : 'Forged Ornate Twisted Scroll',
      'G' : 'Wooden Standard',
      'H' : 'Wooden Tapered',
      'I' : 'Wooden Square',
      'J' : 'Call For More Options',
    }
  }

  /*
  * Number of platform rails lookup
  */
  platformRailObject() {
    return {
      '1' : '1',
      '2' : '2',
    }
  }

  /*
  * Wood species lookup
  */
  woodSpeciesObject() {
    return {
      'A' : 'Red Oak',
      'B' : 'White Oak',
      'C' : 'American Cherry',
      'D' : 'Call For More Options',
    }
  }
}

export default Builder;
